import { IsNotEmpty, IsPositive, IsString, IsUUID, IsInt, Max, IsOptional } from 'class-validator';
import { ChallengeWeekDto } from './challenges-week.dto';
import { ChallengeDto } from './challenges.dto';
import { FileDto } from './file.dto';
import { ChallengeActivityTypesEnum } from '../../enums';

export class ChallengeDayDto {
	public id: string;
	public challengeId: string;
	public weekId: string;
	public sequence: number;
	public titleMarkdown: string;
	public subTitleMarkdown: string;
	public descriptionMarkdown: string;
	public coachAvatarId?: string;
	public coachComment?: string;
	public coachName?: string;
	public emoji?: string;
	public estimatedTime?: string;
	public activityType: ChallengeActivityTypesEnum;

	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public coachAvatar?: FileDto;
	public challenge?: ChallengeDto;
	public week?: ChallengeWeekDto;
}

export class CreateChallengeDayDto {
	@IsNotEmpty()
	@IsInt()
	@Max(7)
	@IsPositive()
	public sequence: number;

	@IsNotEmpty()
	@IsString()
	public titleMarkdown: string;

	@IsNotEmpty()
	@IsString()
	public subTitleMarkdown: string;

	@IsNotEmpty()
	@IsString()
	public descriptionMarkdown: string;

	@IsOptional()
	@IsUUID()
	public coachAvatarId?: string;

	@IsOptional()
	@IsString()
	public coachComment?: string;

	@IsOptional()
	@IsString()
	public coachName?: string;

	@IsOptional()
	@IsString()
	public emoji?: string;

	@IsOptional()
	@IsString()
	public estimatedTime?: string;

	@IsOptional()
	@IsString()
	public activityType?: ChallengeActivityTypesEnum;
}

export class UpdateChallengeDayDto extends CreateChallengeDayDto {}
